import React from "react";

import DataTable from "../../../DataTable";

import useOutputReportStore from "../../../../store/OutputReport.store";
import {
  extractRowKeys,
  formatDataTableColumns,
  getOutputType,
} from "../../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../../utils/resources/dataTableCopy";

const MaturityDataTable = () => {
  const reportName = "Maturity"; // Refer to corresponding API Key
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);

  const { reportType, assetType } = getOutputType(data);

  const footnoteTransition = (
    <>
      [1]{dataTableCopy.existingPortfolioInformation}
      <br />
      [2]{dataTableCopy.proposalNotMaintained}
      <br />
      [3]{dataTableCopy.seeReferenceIndex}
    </>
  );
  const footnoteCash = (
    <>
      {dataTableCopy.unlessOtherwiseStated}
      <br />
      [1]{dataTableCopy.existingPortfolioInformation}
      <br />
      [2]{dataTableCopy.modelAndTransitionAnalysis}
      <br />
      [3]{dataTableCopy.seeReferenceIndex}
    </>
  );

  const revisedCash = (
    <>
      {dataTableCopy.unlessOtherwiseStated}
      <br />
      [1]{dataTableCopy.targetPortfolios}
      <br />
      [2]{dataTableCopy.seeReferenceIndex}
    </>
  );

  const muniLadder = (
    <>
      {dataTableCopy.unlessOtherwiseStated}
      <br />
      [1]{dataTableCopy.existingPortfolioInformation}
      <br />
      [2]{dataTableCopy.modelAndTransitionAnalysis}
      <br />
      [3]{dataTableCopy.seeReferenceIndex}
    </>
  );

  const footnotes = {
    transition: {
      muni: muniLadder,
      corp: footnoteTransition,
      treasury: footnoteTransition,
    },
    cash: {
      muni: footnoteCash,
      corp: revisedCash,
      treasury: revisedCash,
      tbill: revisedCash,
    },
  };

  return (
    <DataTable
      reportType={reportType}
      variation="stylized"
      name="maturity"
      tableCaption={`${reportName} Data Table`}
      tableRowHeaderKey="Maturity (by bucket)"
      tableRowKeys={extractRowKeys(reportName, data)}
      tableColumns={formatDataTableColumns(reportName, data)}
      tableDataTypes={types?.[reportName]}
      formatCellDataBy="row"
      footnote={footnotes[reportType][assetType]}
    />
  );
};

export default MaturityDataTable;
